import axios from 'src/utils/axios';
import { addNotification } from 'src/actions/notificationActions';
import { getAccountInfo } from 'src/actions/accountActions';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';

export const SET_GROUP_TYPE_DETAILS_TAB = '@group-type-details/set-group-type-details-tab';

export const SET_IS_MODAL_LOADING = '@group-type-details/set-modal-loading';
export const SET_IS_MODAL_VISIBLE = '@group-type-details/set-modal-visible';
export const SET_MODAL_MESSAGE = '@group-type-details/set-modal-message';

export const GET_GROUP_TYPE = '@group-type-details/get-group-type';
export const GET_GROUP_TYPE_SUCCESS = '@group-type-details/get-group-type-success';
export const GET_GROUP_TYPE_ERROR = '@group-type-details/get-group-type-error';
export const CLEAR_GROUP_TYPE_DETAILS = '@group-type-details/clear-group-type-details';

export const CREATE_GROUP_TYPE = '@group-type-details/create-group-type';
export const CREATE_GROUP_TYPE_SUCCESS = '@group-type-details/create-group-type-success';
export const CREATE_GROUP_TYPE_ERROR = '@group-type-details/create-group-type-error';

export const UPDATE_GROUP_TYPE = '@group-type-details/update-group-type';
export const UPDATE_GROUP_TYPE_SUCCESS = '@group-type-details/update-group-type-success';
export const UPDATE_GROUP_TYPE_ERROR = '@group-type-details/update-group-type-error';

export const DELETE_GROUP_TYPE = '@group-type-details/delete-group-type';
export const DELETE_GROUP_TYPE_SUCCESS = '@group-type-details/delete-group-type-success';
export const DELETE_GROUP_TYPE_ERROR = '@group-type-details/delete-group-type-error';
export const CLEAR_GROUP_TYPE_WAS_DELETED = '@group-type-details/clear-group-type-was-deleted';

export const GET_ACTION_GROUP_TYPES = '@group-type-details/get-action-group-types';
export const GET_ACTION_GROUP_TYPES_SUCCESS = '@group-type-details/get-action-group-types-success';
export const GET_ACTION_GROUP_TYPES_ERROR = '@group-type-details/get-action-group-types-error';

export const GET_FOLLOW_UP_MESSAGES = '@group-type-details/get-follow-up-messages';
export const GET_FOLLOW_UP_MESSAGES_SUCCESS = '@group-type-details/get-follow-up-messages-success';
export const GET_FOLLOW_UP_MESSAGES_ERROR = '@group-type-details/get-follow-up-messages-error';

export const REPLACE_SYSTEM_GEN_MESSAGE = '@group-type-details/replace-system-gen-message';
export const REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS = '@group-type-details/replace-system-gen-message-success';
export const REPLACE_SYSTEM_GEN_MESSAGE_ERROR = '@group-type-details/replace-system-gen-message-error';

export const SET_FORM_CREATE_UPDATE_GROUP_TYPE = '@group-type-details/set-form-create-update-group-type';

export const SET_UPDATE_GROUP_JOIN_ACTIONS = '@group-type-details/set-update-group-join-actions';

export const SET_FORM_UPDATE_GROUP_TYPE_CONTACT_MESSAGING = '@group-type-details/set-form-update-group-type-contact-messaging';

export const SET_VALUES_WELCOME_MESSAGE = '@group-type-details/set-values-welcome-message';

export const UPDATE_GROUP_TYPE_CONTACT_MESSAGING = '@group-type-details/update-group-type-contact-messaging';
export const UPDATE_GROUP_TYPE_CONTACT_MESSAGING_SUCCESS = '@group-type-details/update-group-type-contact-messaging-success';
export const UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR = '@group-type-details/update-group-type-contact-messaging-error';

export const SET_CURRENT_SMART_ACTION_TYPE = '@group-type-details/set-current-smart-action-type';

export const GET_CUSTOM_FIELDS = '@group-type-details/get-custom-fields';
export const GET_CUSTOM_FIELDS_SUCCESS = '@group-type-details/get-custom-fields-success';
export const GET_CUSTOM_FIELDS_ERROR = '@group-type-details/get-custom-fields-error';

export const setGroupTypeDetailsTab = (tabName) => async (dispatch) => {
  dispatch({
    type: SET_GROUP_TYPE_DETAILS_TAB,
    payload: tabName
  });
};

export const setIsModalVisible = () => ({
  type: SET_IS_MODAL_VISIBLE
});

export const setIsModalLoading = (loading) => ({
  type: SET_IS_MODAL_LOADING,
  payload: loading
});

export const setModalMessage = (isVisible, modalTitle, modalBody) => ({
  type: SET_MODAL_MESSAGE,
  payload: {
    isVisible,
    modalTitle,
    modalBody,
  },
});

export const getGroupType = (groupTypeId) => async (dispatch) => {
  dispatch({
    type: GET_GROUP_TYPE,
  });

  try {
    const response = await axios.get(`/api/groupSettings/grouptypes/${groupTypeId}`);
    dispatch({
      type: GET_GROUP_TYPE_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_GROUP_TYPE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_GROUP_TYPE_ERROR,
    });
  }
};

export const clearGroupTypeDetails = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GROUP_TYPE_DETAILS,
  });
};

export const createGroupType = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_GROUP_TYPE,
    });
    const response = await axios.post('/api/groupSettings/grouptypes/create', { groupTypeChanges: payload });
    const {
      id,
      name,
    } = response?.data || {};

    if (!id) {
      dispatch(addNotification(CREATE_GROUP_TYPE_ERROR, 'Cannot create group type', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CREATE_GROUP_TYPE_ERROR,
      });
      return;
    }

    dispatch(addNotification(CREATE_GROUP_TYPE_SUCCESS, `Group type ${name} has been successfully created`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: CREATE_GROUP_TYPE_SUCCESS,
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(CREATE_GROUP_TYPE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CREATE_GROUP_TYPE_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateGroupType = (groupTypeId, groupTypeChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setIsModalLoading(true));
    dispatch({
      type: UPDATE_GROUP_TYPE,
    });
    const response = await axios.put('/api/groupSettings/grouptypes', {
      groupTypeChanges,
    });
    const {
      success,
    } = response?.data || {};

    if (!success) {
      dispatch(addNotification(UPDATE_GROUP_TYPE_ERROR, 'Can not update group type', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_GROUP_TYPE_ERROR,
      });
      return;
    }

    await dispatch(getGroupType(groupTypeId));
    dispatch(addNotification(UPDATE_GROUP_TYPE_SUCCESS, 'The group type has been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_GROUP_TYPE_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      modalTitle,
      modalBody,
      error,
      message,
    } = e?.response?.data || {};

    if (modalBody) {
      dispatch(setModalMessage(true, modalTitle, modalBody));
    } else if (message) {
      dispatch(setModalMessage(true, 'Type Name Already Exists', ['This type name already exists in active or inactive status.']));
    }

    const { message: errorMessage } = error || {};
    dispatch(addNotification(UPDATE_GROUP_TYPE_ERROR, errorMessage || 'Type didn\'t update', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_GROUP_TYPE_ERROR,
    });
    dispatch(setIsModalLoading(false));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const deleteGroupType = (groupTypeId) => async (dispatch) => {
  try {
    dispatch(setIsModalLoading(true));
    dispatch({
      type: DELETE_GROUP_TYPE,
    });
    const response = await axios.delete(`/api/groupSettings/grouptypes/${groupTypeId}`);
    const {
      success,
      error,
    } = response?.data || {};

    dispatch({
      type: DELETE_GROUP_TYPE_SUCCESS,
      success,
    });

    if (error) {
      dispatch(addNotification(DELETE_GROUP_TYPE_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch(setIsModalLoading(false));
      return;
    }

    if (!success) {
      dispatch(getGroupType(groupTypeId));
      dispatch(addNotification(DELETE_GROUP_TYPE_ERROR, `Can not delete group type ${groupTypeId}`, NOTIFICATION_STATUS.ERROR));
      return;
    }
    dispatch(addNotification(DELETE_GROUP_TYPE_SUCCESS, 'Group type deleted successfully', NOTIFICATION_STATUS.SUCCESS));
  } catch (e) {
    const {
      deleteOrInactivate,
      modalTitle,
      modalBody,
      error,
      message,
    } = e?.response?.data || {};

    if (modalBody) {
      dispatch(setModalMessage(true, modalTitle, modalBody));
    } else if (deleteOrInactivate === 'Inactivate') {
      dispatch(setModalMessage(true, 'Inactivated Instead of Deleted', ['The type was inactivated instead of deleted, because at least one Group is using this type.', 'If you want to delete this type, go to the groups screen and change the type of those group(s), then return here to actually delete it.']));
    }

    dispatch(addNotification(DELETE_GROUP_TYPE_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch(getGroupType(groupTypeId));
    dispatch({
      type: DELETE_GROUP_TYPE_ERROR,
    });
  }
};

export const clearGroupTypeWasDeleted = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GROUP_TYPE_WAS_DELETED,
  });
};

export const getGroupSmartActionTypes = () => async (dispatch) => {
  dispatch({
    type: GET_ACTION_GROUP_TYPES,
  });
  try {
    const response = await axios.get('/api/groupSettings/actiongrouptypes');

    dispatch({
      type: GET_ACTION_GROUP_TYPES_SUCCESS,
      payload: response?.data || [],
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_ACTION_GROUP_TYPES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_ACTION_GROUP_TYPES_ERROR,
    });
  }
};

export const setFormCreateUpdateGroupType = (payload) => ({
  type: SET_FORM_CREATE_UPDATE_GROUP_TYPE,
  payload
});

export const setUpdateGroupJoinActions = (payload) => async (dispatch) => {
  dispatch({
    type: SET_UPDATE_GROUP_JOIN_ACTIONS,
    payload,
  });
};

// CON-1621 — contexts limits the picker to template scopes that can
// actually resolve on this surface's send path. Omitted means the server
// returns contact scope only (fail closed).
export const getFollowUpMessages = (contexts = null) => async (dispatch) => {
  try {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES,
    });
    const { data } = await axios.post('/api/followupmessages/template-tag', contexts ? { contexts } : {}) || {};
    const { error } = data || {};

    if (error) {
      dispatch({
        type: GET_FOLLOW_UP_MESSAGES_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
      payload: data?.messages,
    });
  } catch (e) {
    dispatch({
      type: GET_FOLLOW_UP_MESSAGES_ERROR,
    });
  }
};

export const clearFollowUpMessages = () => ({
  type: GET_FOLLOW_UP_MESSAGES_SUCCESS,
});

export const replaceSystemGenMessage = (systemGenMessage, dynamicFieldsObj) => async (dispatch) => {
  try {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE,
    });
    const { data } = await axios.post('/api/contacts/replace-system-gen-message', {
      systemGenMessage,
      ...dynamicFieldsObj,
    }) || {};

    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_SUCCESS,
      payload: data?.message,
    });
  } catch (e) {
    dispatch({
      type: REPLACE_SYSTEM_GEN_MESSAGE_ERROR,
    });
  }
};

export const setFormGroupTypeGuestMessaging = (payload) => ({
  type: SET_FORM_UPDATE_GROUP_TYPE_CONTACT_MESSAGING,
  payload
});

export const setValuesWelcomeMessage = (values) => ({
  type: SET_VALUES_WELCOME_MESSAGE,
  payload: values
});

export const updateGroupTypeNewContacMessaging = (groupTypeId, groupTypeContactMessagingChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  try {
    dispatch({
      type: UPDATE_GROUP_TYPE_CONTACT_MESSAGING,
    });
    const {
      updateGroupJoinActions,
    } = getState()?.groupTypeDetails || {};
    const response = await axios.put('/api/groupSettings/groupTypeContactMessaging', {
      groupTypeContactMessagingChanges,
      updateGroupJoinActions,
    });
    const {
      success,
    } = response?.data || {};

    if (!success) {
      dispatch(addNotification(UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR, 'Can not update group type', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR,
      });
      return;
    }

    await dispatch(getGroupType(groupTypeId));
    dispatch(addNotification(UPDATE_GROUP_TYPE_CONTACT_MESSAGING_SUCCESS, 'Join Actions has been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_GROUP_TYPE_CONTACT_MESSAGING_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      modalTitle,
      modalBody,
      error,
      message,
    } = e?.response?.data || {};

    if (modalBody) {
      dispatch(setModalMessage(true, modalTitle, modalBody));
    } else if (message) {
      dispatch(setModalMessage(true, 'Could not update the message, categories or groups.'));
    }

    const { message: errorMessage } = error || {};
    dispatch(addNotification(UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR, errorMessage || 'Could not update the message, categories or groups.', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_GROUP_TYPE_CONTACT_MESSAGING_ERROR,
    });
    dispatch(setIsModalLoading(false));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const setCurrentSmartActionType = (typeName) => ({
  type: SET_CURRENT_SMART_ACTION_TYPE,
  payload: typeName
});

export const getCustomFields = (groupTypeId) => async (dispatch) => {
  dispatch({
    type: GET_CUSTOM_FIELDS,
  });
  try {
    const response = await axios.get(`/api/groupSettings/grouptypes/${groupTypeId}/custom-fields`);

    dispatch({
      type: GET_CUSTOM_FIELDS_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CUSTOM_FIELDS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CUSTOM_FIELDS_ERROR,
    });
  }
};

export const clearCustomFields = () => ({
  type: GET_CUSTOM_FIELDS_SUCCESS,
});
